module.exports = __webpack_public_path__ + "static/media/Computer-Applications.134995d1.webp";